
export enum RightGrantsEnum {
    View = 0,
    Add = 1,
    Edit = 2,
    Delete = 3,
    Admin = 20
}